export default "__VITE_ASSET__CdufN7JE__"